import { markupTemplateLang, clikeComment } from "./shared"

markupTemplateLang("soy", clikeComment)
